(function() { window.GUID_f9696352_33db_4662_92c6_b71fe62dfc84 = { getGuid: function() { return "f9696352-33db-4662-92c6-b71fe62dfc84"; } }; })();
var CompuSport;
(function (CompuSport) {
    function GetCookie(cookieName) {
        return $.cookie('CSCookie.' + cookieName);
    }
    CompuSport.GetCookie = GetCookie;
    function SetCookie(cookieName, value) {
        $.removeCookie('CSCookie.' + cookieName);
        $.cookie('CSCookie.' + cookieName, value, { expires: 365, path: '/' });
    }
    CompuSport.SetCookie = SetCookie;
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=Cookie.js.map
